import { Divider as AntdDivider, DividerProps as AntdDividerProps } from "antd/es";
import { Guid } from "guid-typescript";
import _ from "lodash";
import React, { CSSProperties, PureComponent, ReactNode } from "react";
import isEqual from "react-fast-compare";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import DynamicStyleManager from "../../../shared/utilty/dynamic-style-manager";
import { CommonProps } from "../common-props";

interface DividerProps extends AntdDividerProps {
  label: string;
  dashed: boolean;
  orientation: "left" | "right" | "center";
  type: "horizontal" | "vertical";
  style: CSSProperties;
}

interface DividerState {}

declare let window: any;

class Divider extends PureComponent<DividerProps & CommonProps, DividerState> {
  private uniqueKey = Guid.create();

  private style = new DynamicStyleManager(`kdivider_${this.uniqueKey}`);

  constructor(props: DividerProps) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {
    this.setDynamicStyle();
  };

  componentDidUpdate(prevProps: DividerProps) {
    if (!isEqual(prevProps, this.props)) {
      this.setDynamicStyle();
    }
  }

  componentWillUnmount = () => {
    this.style.removeStyle();
  };

  getClassName = () => {
    // if(props.style.borderStyle){
    //   return props.className ? `${props.className} kuika-divider-component__divider-line-${props.style.borderStyle}` : `kuika-divider-component__divider-line-${props.style.borderStyle}`
    // }else{
    let result = "";
    if (!this.uniqueKey) {
      return result;
    }
    result = `${result}kdivider_${this.uniqueKey.toString().substring(0, 8)}`;
    return result;
    // }
  };

  getProps = () => {
    const props: any = _.clone(this.props);
    const style: any = _.clone(this.props.style || {});
    if (style.display) {
      delete style.display;
    }
    [
      "border",
      "borderStyle",
      "borderColor",
      "borderWidth",
      "borderTop",
      "borderRight",
      "borderBottom",
      "borderLeft",
      "borderTopStyle",
      "borderRightStyle",
      "borderBottomStyle",
      "borderLeftStyle",
      "borderTopColor",
      "borderRightColor",
      "borderBottomColor",
      "borderLeftColor",
      "borderTopWidth",
      "borderRightWidth",
      "borderBottomWidth",
      "borderLeftWidth"
    ].forEach((key) => {
      if (key in style) {
        delete style[key];
      }
    });
    props.style = style;

    const ownClassName = this.getClassName();
    const callerClassName = typeof this.props.className === "string" ? this.props.className : "";
    const className = `${ownClassName} ${callerClassName}`.trim();
    if (className) props.className = className;

    if ("label" in props) {
      delete props.label;
    }

    const nonDOMAttributes = ["data-testid", "data-cy", "data-test", "orientation", "dashed", "type"];
    nonDOMAttributes.forEach((attr) => {
      if (props[attr] !== undefined) {
        delete props[attr];
      }
    });

    return props;
  };

  getDividerBorderWidth = (): CSSProperties["borderWidth"] => {
    const style: React.CSSProperties = _.clone(this.props.style);
    if (!style) return;

    if (style.borderWidth) {
      return style.borderWidth;
    }

    if (style.borderTopWidth) {
      return style.borderTopWidth;
    }

    if (style.borderRightWidth) {
      return style.borderRightWidth;
    }

    if (style.borderBottomWidth) {
      return style.borderBottomWidth;
    }

    if (style.borderLeftWidth) {
      return style.borderLeftWidth;
    }

    return;
  };

  getOrientation = () => {
    const result = "left";
    if (this.props && this.props.style) {
      const style: any = _.clone(this.props.style);
      if (style.textAlign) {
        if (style.textAlign.includes("center")) return "center";
        if (style.textAlign.includes("left")) return "left";
        if (style.textAlign.includes("right")) return "right";
      }
    }
    return result;
  };

  getDynamicCss = (): string => {
    const className: string = this.getClassName();
    if (!className || className.length === 0) {
      return "";
    }
    let result = "";

    const isReportDesigner = window.kuika?.dashboardState === 17;

    const { borderColor, borderStyle, height } = this.props.style || {};
    const borderWidth = this.getDividerBorderWidth();
    const orientation = this.getOrientation();
    const bwCss = borderWidth ? (typeof borderWidth === "number" ? `${borderWidth}px` : `${borderWidth}`) : undefined;
    const hasLabel = typeof this.props.label === "string" && this.props.label.trim().length > 0;

    if (borderColor) {
      result += `.${className.trim()}.ant-divider-horizontal { border-top-color: ${borderColor} !important; }`;
      result += `.${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:before, .${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:after { border-top-color: ${borderColor} !important; }`;
    }
    if (height || bwCss) {
      if (bwCss) {
        result += `.${className.trim()}.ant-divider-horizontal { border-top-width: ${bwCss} !important; }`;
        result += `.${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:before, .${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:after { border-top-width: ${bwCss} !important; }`;
      }
      if (height) {
        result += `.${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:before, .${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:after { top: 0% !important; transform: unset; border-style: inherit; }`;
      }
    }
    if (isReportDesigner) {
      result += `.${className.trim()} .ant-divider-inner-text {
        display: none !important;
      }`;
      result += `.${className.trim()} {
        margin: 0 !important;
        height: 12px !important;
      }`;
      if (!borderWidth) {
        result += `.${className.trim()} {
          border-top-width: 1px !important;
        }`;
      }
      if (borderStyle) {
        result += `.${className.trim()}.ant-divider-horizontal { border-top-style: ${borderStyle} !important; }`;
        result += `.${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:before, .${className.trim()}.ant-divider-horizontal.ant-divider-with-text-${orientation}:after { border-top-style: ${borderStyle} !important; }`;
      }
    }

    if (this.props.dashed && this.props.type !== "vertical" && !hasLabel) {
      result += `.${className.trim()}.ant-divider-horizontal { border-top-style: dashed !important; }`;
    }

    return result;
  };

  setDynamicStyle = () => {
    this.style.setDynamicCss(this.getDynamicCss());
  };

  render(): ReactNode {
    const hasLabel = typeof this.props.label === "string" && this.props.label.trim().length > 0;
    return (
      <AntdDivider
        {...this.getProps()}
        dashed={this.props.dashed}
        type={this.props.type}
        orientation={this.getOrientation()}
      >
        {hasLabel ? this.props.label : null}
      </AntdDivider>
    );
  }
}

const kIframe = withCommonEvents(Divider);
export { kIframe as Divider };
